const NotFound = () => {
  return(
    <div>
      No se ha encontrado una guía para el error indicado
    </div>
  )
};

export default NotFound;